export const PipeColor = {
  rt: '#ff0000',
  gn: '#00ff00',
  bl: '#0000ff',
  ge: '#ffff00',
  ws: '#ffffff',
  gr: '#cccccc',
  br: '#663300',
  vi: '#ff00ff',
  tk: '#00ffff',
  sw: '#000000',
  or: '#ff9900',
  rs: '#ff99ff',
};

// There are max 24 speedpipes colors
export const pipeColors = [
  ...Object.entries(PipeColor),
  ...Object.entries(PipeColor).map(([code, color]) => [code + '—', color]),
] as const;

export const colorsForTelekomDBB = [
  {
    name: 'orange',
    color: '#ff8000',
  },
  {
    name: 'weiss',
    color: '#d4d4d4',
  },
  {
    name: 'weiss-',
    color: '#ffffff',
  },
  {
    name: 'violett',
    color: '#c000ff',
  },
  {
    name: 'violett-',
    color: '#d440ff',
  },
  {
    name: 'tuerkis',
    color: '#00ffc0',
  },
  {
    name: 'tuerkis-',
    color: '#60ffc0',
  },
  {
    name: 'schwarz',
    color: '#000000',
  },
  {
    name: 'schwarz-',
    color: '#404040',
  },
  {
    name: 'rot',
    color: '#ff0000',
  },
  {
    name: 'rot-',
    color: '#ff8080',
  },
  {
    name: 'rosa',
    color: '#ff80ff',
  },
  {
    name: 'rosa-',
    color: '#ffc0ff',
  },
  {
    name: 'orange-',
    color: '#ffc080',
  },
  {
    name: 'grau',
    color: '#808080',
  },
  {
    name: 'grau-',
    color: '#c0c0c0',
  },
  {
    name: 'gruen',
    color: '#00ff00',
  },
  {
    name: 'gruen-',
    color: '#80ff80',
  },
  {
    name: 'gelb',
    color: '#ffff00',
  },
  {
    name: 'gelb-',
    color: '#ffff80',
  },
  {
    name: 'braun',
    color: '#804040',
  },
  {
    name: 'braun-',
    color: '#c08080',
  },
  {
    name: 'blau',
    color: '#0000ff',
  },
  {
    name: 'blau-',
    color: '#8080ff',
  },
];
